import { render, staticRenderFns } from "./AllItemsBlock.vue?vue&type=template&id=e9b493d6"
import script from "./AllItemsBlock.vue?vue&type=script&lang=js"
export * from "./AllItemsBlock.vue?vue&type=script&lang=js"
import style0 from "./AllItemsBlock.vue?vue&type=style&index=0&id=e9b493d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports